import React, { useState } from 'react';
import './Hosting.css';
import HostingListings from '../components/HostingListings';
import HostingCalendar from './HostingCalendar';
import HostingMessages from './HostingMessages';

function Hosting() {
  const [activeTab, setActiveTab] = useState('listings');

  return (
    <div className="hosting-container">
      <div className="hosting-header">
        <h1>Your Hosting</h1>
      </div>

      <div className="hosting-tabs">
        <button 
          className={`tab-btn ${activeTab === 'listings' ? 'active' : ''}`}
          onClick={() => setActiveTab('listings')}
        >
          📋 Listings
        </button>
        <button 
          className={`tab-btn ${activeTab === 'calendar' ? 'active' : ''}`}
          onClick={() => setActiveTab('calendar')}
        >
          📅 Calendar
        </button>
        <button 
          className={`tab-btn ${activeTab === 'messages' ? 'active' : ''}`}
          onClick={() => setActiveTab('messages')}
        >
          💬 Messages
        </button>
      </div>

      <div className="hosting-content">
        {activeTab === 'listings' && <HostingListings />}
        {activeTab === 'calendar' && <HostingCalendar />}
        {activeTab === 'messages' && <HostingMessages />}
      </div>
    </div>
  );
}

export default Hosting;
